var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isManager && !_vm.getFakeUser)?_c('AdminLK'):((_vm.isManager && _vm.getFakeUser) || !_vm.isExpert  && !_vm.isTest)?_c('ApplicantsKorolev'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }